<template>
  <div>
    <Header />

    <div class="Auth">
      <div class="Auth__image"></div>
      <div class="Auth__form">
        <div class="w-full">
          <!-- Form -->
          <h1 class="md:text-4xl mb-3 text-3xl font-extrabold leading-tight">Become a stronger cyclist.</h1>
          <p class="mb-6 text-lg">
            Connect Strava and FormBeat automatically turns every ride into clear, actionable insights.
            <br class="sm:block hidden" />
            Revoke access anytime.
          </p>

          <button class="md:w-auto flex justify-center w-full p-0 mb-3 -ml-1 rounded cursor-pointer" style="background: #fc4c01" @click="connectStrava()">
            <img src="~images/connect-with-strava.svg" alt="Connect with Strava" width="220" />
          </button>

          <!--<label class="mb-4 cursor-pointer select-none">
            <Checkbox v-model="privateScope" class="mr-1" />
            Include private activities
          </label>-->

          <p class="mt-3 text-sm text-gray-600">
            Or
            <button class="text-link font-bold underline" @click="connectGarmin()">sign up with Garmin &raquo;</button>
          </p>

          <p class="pt-6 mt-8 border-t">
            Already have an account?
            <router-link :to="{ name: 'signIn' }" class="text-link font-bold">Sign in &raquo;</router-link>
          </p>

          <div class="py-16 mt-6">
            <img loading="lazy" src="~images/logos/roadcc.svg" alt="Road.cc" class="w-28 mb-4" style="filter: invert(1)" />
            <div class="text-muted text-lg italic">
              “If you find yourself wishing there was just one simple resource you could rely on to fully explain, examine and guide your training, FormBeat
              could be your answer.”
            </div>
            <img src="~images/icons/stars.svg" alt="" loading="lazy" class="w-20 my-4" />
            <div class="text-muted max-w-xs mt-4 text-sm">Join 20,000+ cyclists who use FormBeat to get actionable insights from their training</div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import StravaService from 'services/StravaService'
import GarminService from 'services/GarminService'
import AnalyticsService from 'services/AnalyticsService'

import ConnectGarminModal from 'views/Modals/ConnectGarminModal'

import Header from 'components/Header'
import Footer from 'components/Footer'

export default {
  components: {
    Header,
    Footer
  },

  data() {
    return {
      privateScope: true
    }
  },

  methods: {
    async connectStrava() {
      StravaService.connect(this.privateScope)
      AnalyticsService.trackEvent('conversion', 'connect-with-strava')
      AnalyticsService.ahoyTrackEvent('connect-with-strava')
    },

    async connectGarmin() {
      // Explain the permission screen before handing off — most users leave
      // Garmin's historical-data box unticked, which leaves us with no past
      // rides to analyze.
      const confirmed = await this.$modal(ConnectGarminModal, { garminPrimary: true })
      if (!confirmed) return

      GarminService.connect()
      AnalyticsService.trackEvent('conversion', 'connect-with-garmin')
      AnalyticsService.ahoyTrackEvent('connect-with-garmin')
    }
  },

  metaInfo() {
    return {
      title: 'Start Training Smarter',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Sign up and start improving your cycling performance'
        }
      ]
    }
  }
}
</script>
